
import Vue from 'vue'

export default Vue.extend({
  name: 'ParticipateFormSelector',
  props: {
    value: {
      type: Boolean,
    },
    contestSlug: {
      type: String,
    },
  },
  data: () => ({}),
  methods: {
    createNewProjectClick: function () {
      if (
        this.$store.state.authentication.user.status === 'waiting_for_parent'
      ) {
        this.$store.dispatch(
          'alert/warning',
          "We are waiting for your parent's consent so you can't add new projects."
        )
        return
      }
      this.$router.push('/project/new?contest=' + this.contestSlug)
    },
  },
})
